import script from "./DayPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./DayPicker.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/calendar.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__